/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const procedureDivorceSectionStyle = {
  centered: {
    textAlign: "center",
  },
  paper: {
    padding: "2rem",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  gridContainer: {
    marginTop: "40px",
  },
  icon: (theme: Theme) => ({
    width: "128px",
    height: "128px",

    [theme.breakpoints.only("xs")]: {
      maxWidth: "90px",
      maxHeight: "90px",
    },
  }),
  gridItemReversed: (theme: Theme) => ({
    [theme.breakpoints.only("xs")]: {
      order: -1,
    },
  }),
  questions: {
    color: "primary.main",
    marginTop: "50px",
  },
};

export default procedureDivorceSectionStyle;
